import { useNavigate } from "react-router-dom";
import { MdErrorOutline } from "react-icons/md";
import Button from "../components/common/Button";
import { useTranslation } from "react-i18next";

const NotFoundPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="h-[calc(100vh)] flex flex-col px-6 py-8 ">
      <div className="flex-1 space-y-6">
        <MdErrorOutline className=" text-5xl" />
        <h1 className="text-xl font-bold text-gray-800 ">{t("not_found_page")}</h1>
        <p className="text-gray-700 ">{t("check_url")}</p>
      </div>
      <Button onClick={() => navigate(-1)}>{t("back")}</Button>
    </div>
  );
};

export default NotFoundPage;
